import { Card, Typography } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'
import {
    DESIGNER_SUMMARY_LABELS,
    DIGITAL_RATE_BRACKETS,
    DesignerRateBracket,
    FLEXO_RATE_BRACKETS,
    OVERTIME_HOUR_RATE,
} from '../constants/designer-summary-labels'

const HintCard = styled(Card)`
    width: fit-content;
    max-width: 100%;

    & .ant-card-body {
        padding: 12px 16px;
    }
`

const HintTitle = styled(Typography.Text)`
    display: block;
    margin-bottom: 8px;
    font-size: 12px;
`

const SectionTitle = styled(Typography.Text)`
    display: block;
    margin-top: 8px;
    margin-bottom: 4px;
    font-size: 12px;
`

const RateRow = styled(Typography.Text)<{ $active?: boolean }>`
    display: block;
    font-size: 12px;
    line-height: 1.6;
    white-space: nowrap;
    font-weight: ${p => (p.$active ? 600 : 400)};
    color: ${p => (p.$active ? p.theme.colorSuccess : undefined)};
`

interface BonusRatesHintProps {
    flexoRate: number | null
    digitalRate: number | null
}

function RateList({
    brackets,
    currentRate,
}: {
    brackets: DesignerRateBracket[]
    currentRate: number | null
}) {
    return (
        <>
            {brackets.map(bracket => (
                <RateRow key={bracket.label} $active={currentRate === bracket.rate}>
                    {bracket.label}: {bracket.rate}
                    {currentRate === bracket.rate ? ' ← текущая' : ''}
                </RateRow>
            ))}
        </>
    )
}

const BonusRatesHint: FC<BonusRatesHintProps> = ({ flexoRate, digitalRate }) => {
    return (
        <HintCard size='small'>
            <HintTitle type='secondary'>{DESIGNER_SUMMARY_LABELS.ratesHint}</HintTitle>

            <SectionTitle strong>{DESIGNER_SUMMARY_LABELS.flexo}</SectionTitle>
            <RateList brackets={FLEXO_RATE_BRACKETS} currentRate={flexoRate} />

            <SectionTitle strong>{DESIGNER_SUMMARY_LABELS.digital}</SectionTitle>
            <RateList brackets={DIGITAL_RATE_BRACKETS} currentRate={digitalRate} />

            <SectionTitle strong>{DESIGNER_SUMMARY_LABELS.overtime}</SectionTitle>
            <RateRow>1 час переработки: {OVERTIME_HOUR_RATE}</RateRow>
        </HintCard>
    )
}

export default BonusRatesHint
